import React from 'react'
import { HERO_IMAGE } from '../helpers/constants'
import Button from './MainButton'

const Component = (): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <div data-type='hero-image'>
      <picture data-type='image'>
        <img
          width='1440'
          height='535'
          itemProp='image'
          src={HERO_IMAGE}
          alt='hero'
          role='presentation'
          data-type='image'
        />
      </picture>
      <h1>Sell your art to a global community of art lovers</h1>
      <Button dataStyle='hero-button' modalName='from-hero' />
    </div>
  )
}

export default Component